import React, { useEffect, useRef, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import { errorService } from 'services/alert/services';

import CreateOrUpdateScheduleModal, { staticYearMonthDay } from './create-or-update-schedule-modal';
import { tournamentType, isType, modes } from './utils';
import { TournamentScheduleService } from 'services/api/tournament-schedule';
import dayjs from 'dayjs';

const styles = {
  increaseBalance: {
    color: '#2eb92e',
  },
  decreaseBalance: {
    color: '#e01919',
  },
  takingReservedBalance: {
    color: '#707070',
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
  },
};

const useStyles = makeStyles(styles);

const TournamentSchedules = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [openCreateTournamentModal, setOpenCreateTournamentModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [openUpdateTournamentModal, setOpenUpdateTournamentModal] = useState(false);

  const tableRef = useRef();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await TournamentScheduleService.findAll();
      setData(response.data.schedules);
    } catch (e) {
      errorService.sendError('Произошла ошибка' + e.message);
    }
  };

  const handleCreateModalClose = () => {
    setOpenCreateTournamentModal(false);
  };

  const handleUpdateModalClose = () => {
    setOpenUpdateTournamentModal(false);
    setSelectedSchedule(null);
  };

  const onRowDelete = async (oldData) => {
    try {
      await TournamentScheduleService.deleteByID(oldData._id);
      // @ts-ignore
      setData((tournaments) => tournaments.filter((t) => t._id !== oldData._id));
    } catch (e) {
      errorService.sendError('Произошла ошибка' + e.message);
    }
  };

  const onCreate = async (values) => {
    const body = {
      title: values.title,
      templateId: values.templateId,
      startAt: values.startAt,
      weekDays: values.weekDays,
      isActive: values.isActive,
    };
    try {
      await TournamentScheduleService.create(body);
      await fetchData();
      handleCreateModalClose();
    } catch (e) {
      errorService.sendError(e?.message);
    }
  };

  const onUpdate = async (newValues, prevValues) => {
    const body = {
      title: newValues.title,
      templateId: newValues.templateId,
      startAt: newValues.startAt,
      weekDays: newValues.weekDays,
      isActive: newValues.isActive,
    };
    try {
      await TournamentScheduleService.updateByID((selectedSchedule as any)?._id, body);
      handleUpdateModalClose();
      fetchData();
    } catch (e) {
      errorService.sendError(e.message);
    }
  };

  return (
    <div>
      {openCreateTournamentModal && (
        <CreateOrUpdateScheduleModal
          open={true}
          handleClose={handleCreateModalClose}
          onSubmit={onCreate}
          mode={modes.create}
          schedule={null}
        />
      )}
      {openUpdateTournamentModal && (
        <CreateOrUpdateScheduleModal
          open={true}
          handleClose={handleUpdateModalClose}
          onSubmit={onUpdate}
          schedule={selectedSchedule}
          mode={modes.update}
        />
      )}
      <GridContainer>
        {/* @ts-ignore */}
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <p className={classes.cardTitleWhite}>Управление турнирами</p>
            </CardHeader>
            <CardBody>
              {/* @ts-ignore */}
              <MaterialTable
                title="Турниры"
                tableRef={tableRef}
                actions={[
                  {
                    icon: 'add',
                    tooltip: 'Создать турнир',
                    isFreeAction: true,
                    onClick: () => setOpenCreateTournamentModal(true),
                  },
                  {
                    icon: 'edit',
                    tooltip: 'Обновить турнир',
                    onClick: (_, rowData) => {
                      setSelectedSchedule(rowData);
                      setOpenUpdateTournamentModal(true);
                    },
                  },
                ]}
                localization={{
                  body: {
                    deleteTooltip: 'Удалить',
                    editRow: {
                      deleteText: 'Вы уверены что хотите удалить турнир?',
                    },
                  },
                  toolbar: { searchPlaceholder: 'Поиск' },
                  pagination: { labelRowsSelect: 'cтрок' },
                  header: {
                    actions: 'Действия',
                  },
                }}
                columns={[
                  {
                    title: 'ID',
                    field: '_id',
                  },
                  {
                    title: 'Название',
                    field: 'title',
                  },
                  {
                    title: 'Запускается в',
                    field: 'startAt',
                    render: (rowData) => {
                      return dayjs(staticYearMonthDay).startOf("day").add(rowData.startAt, "seconds").format("HH:mm")
                    },
                  },
                  {
                    title: 'Шаблон',
                    field: 'templateId',
                  },
                ]}
                data={data}
                options={{
                  filtering: true,
                  search: false,
                }}
                editable={{
                  isEditable: () => true,
                  onRowAddCancelled: () => console.log('Row adding cancelled'),
                  onRowUpdateCancelled: () => console.log('Row editing cancelled'),
                  onRowDelete,
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default TournamentSchedules;
